import Vue from 'vue'
import moment from 'moment'

Vue.filter('profileName', (val) => {
  switch (val) {
    case 'administrator':
      return 'Administrador'
    case 'manager':
      return 'Gerente'
    case 'supervisor':
      return 'Supervisor'
    case 'attendant':
      return 'Atendente'
    default:
      return '---'
  }
})

Vue.filter('date', (val) => {
  if (val) {
    if (val && typeof val === 'object' && ['Timestamp', 't'].indexOf(val.constructor.name) > -1) {
      if (val.toDate) {
        val = val.toDate()
      }
    }
    return moment(val).format('DD/MM/YYYY')
  }
})

Vue.filter('dateTime', (val) => {
  if (val) {
    if (val && typeof val === 'object' && ['Timestamp', 't'].indexOf(val.constructor.name) > -1) {
      if (val.toDate) {
        val = val.toDate()
      }
    }
    return moment(val).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('shortDate', (val) => {
  if (val) {
    if (val && typeof val === 'object' && ['Timestamp', 't'].indexOf(val.constructor.name) > -1) {
      if (val.toDate) {
        val = val.toDate()
      }
    }
    return moment(val).format('DD/MM')
  }
})
